import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { injectIntl, defineMessages } from 'react-intl'
import { compose } from 'recompose'
import {
  initAnswers,
  updateAnswers,
  setResult,
} from '../../common/tests/actions'
import { RadioInput, Checkbox, LessonMediaContent } from '../components'

class OptionsTestPreview extends React.Component {

  render() {
    const { lesson } = this.props
    const { questions } = lesson.options

    return (
      <div className="options-item-preview column-direction">
        {/*
        <LessonMediaContent lesson={lesson} />
        */}
        <div className="width-full">
          {
            questions.map((q, qid) => (
              <div
                key={`${q.text}${qid}`}
                className="question-item width-full column-direction item-box"
              >
                <div className="question-text-box in-test width-full">
                  <p>{q.text}</p>
                </div>
                <div className="question-answers">
                  {
                    q.answers.map((ans, aid) => (
                      <div key={`${qid}${ans}${aid}`}>
                        {
                          lesson.options.onlyOneCorrect ?
                            <RadioInput
                              id={`${qid}${ans}${aid}`}
                              disabled={true}
                              label={ans}
                              checked={q.correctAnswers.includes(aid)}
                            />
                          :
                            <Checkbox
                              id={`${qid}${ans}${aid}`}
                              disabled={true}
                              checked={q.correctAnswers.includes(aid)}
                              label={ans}
                            />
                        }
                      </div>
                    ))
                  }
                </div>
              </div>
            ))
          }
        </div>
      </div>
    )
  }
}

OptionsTestPreview.defaultProps = {
  lesson: null,
}

OptionsTestPreview.propTypes = {
  intl: PropTypes.object.isRequired,
  lesson: PropTypes.object,
}

const enhance = compose(
  connect(state => ({
    exam: state.tests.exam,
  }), { updateAnswers, initAnswers, setResult }, null, { withRef: true }),
)


export default enhance(OptionsTestPreview)

const messages = defineMessages({
  chooseCorrect: {
    id: 'optionsTestPreview.chooseCorrect',
    defaultMessage: 'Vyberte správnu odpoveď.',
  },
  points: {
    id: 'optionsTestPreview.points',
    defaultMessage: 'Body',
  },
})



// WEBPACK FOOTER //
// ./src/browser/components/OptionsTestPreview.js